enum RequestStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCEESS = 'SUCCEESS',
  FAILURE = 'FAILURE',
}

export default RequestStatus;
